<template>
    <section class="section df">
        <div class="l-box">
            <div class="nav-title">
                我的关注
            </div>

            <router-link :to="`/spaces/${id}/follow`" exact class="nav-item">
                <div class="nav-name"><i class="icon-user"></i>关注的用户</div>
                {{up.follows}}
            </router-link>

            <router-link :to="`/spaces/${id}/follow/dancers`" class="nav-item">
                <div class="nav-name"><i class="icon-dancer"></i>关注的舞者</div>
                {{up.follow_dancers}}
            </router-link>

            <router-link :to="`/spaces/${id}/follow/studios`" class="nav-item">
                <div class="nav-name"><i class="icon-studio"></i>关注的工作室</div>
                {{up.follow_studios}}
            </router-link>

            <div class="nav-title">
                我的粉丝
            </div>

            <router-link :to="`/spaces/${id}/follow/fans`" exact class="nav-item">
                <div class="nav-name"><i class="icon-user"></i>{{id === uid ? '我' : 'TA'}}的粉丝</div>
                {{up.fans}}
            </router-link>
        </div>
        <div class="r-box">
            <router-view
                    :up="up"
                    @fansDecr="() => fans--"
                    @userIncr="() => $emit('userIncr')"
                    @userDecr="() => $emit('userDecr')"
                    @dancerIncr="() => $emit('dancerIncr')"
                    @dancerDecr="() => $emit('dancerDecr')"
                    @studioIncr="() => $emit('studioIncr')"
                    @studioDecr="() => $emit('studioDecr')"
            ></router-view>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            up: Object,
        },
        data: () => ({
            fans: 0,
            user: 0,
            dancer: 0,
            studio: 0,
        }),
        computed: {
            id() {
                return +this.$route.params.id;
            },
            uid() {
                return this.$store.state.user.id;
            }
        },
        methods: {

        },
        beforeMount() {
            /*this.api.get(`user/${this.id}/follow/count`).then(e => {
                this.is_loading = false;
                this.fans = e.fans;
                this.user = e.user;
                this.dancer = e.dancer;
                this.studio = e.studio;
            }, e => {
                this.is_loading = false;
                this.alert.err(e.message);
            });*/

        }
    }
</script>

<style scoped>
    @import "../../../../static/css/views/space/collect/nav.css";
</style>


// WEBPACK FOOTER //
// src/views/space/follow/Nav.vue